"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Pagination = /** @class */ (function () {
    function Pagination(json) {
        if (json === void 0) { json = {}; }
        this.offset = json.offset ? parseInt(json.offset, 10) : 0;
        this.limit = json.limit ? parseInt(json.limit, 10) : 100000;
    }
    __decorate([
        mobx_1.observable
    ], Pagination.prototype, "offset", void 0);
    __decorate([
        mobx_1.observable
    ], Pagination.prototype, "limit", void 0);
    return Pagination;
}());
exports.Pagination = Pagination;
//# sourceMappingURL=CommonModels.js.map